import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flexbox-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "material-icons" }, " done ", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "material-icons" }, " block ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "material-icons" }, " outgoing_mail ", -1)


import UiButton from '../ui/UiButton.vue';
import { client } from '@/api/client-v2';
import { useStore } from '@/store/store';
import { showSuccessToast, showToast } from '@/services/error-management.service';
import { ManagerUser } from '@/api/types';


export default _defineComponent({
  props: {
    user: { type: null, required: true }
  } as unknown as undefined,
  emits: ['updated'],
  setup(__props: {
    user: ManagerUser;
}, { emit }) {

const props = __props
const store = useStore();





const sendInviteEmail = async () => {
    try {
        await client.resendManagerInvitation({ userId: props.user.id, clubId: store.getters.getMyClub.club_id });
        showSuccessToast('Email di invito inviata con successo');
    } catch {
        showToast('si è verificato un errore')
    }
}

const enableManager = async () => {
    try {
        await client.enableManager({ userId: props.user.id, clubId: store.getters.getMyClub.club_id });
        emit('updated');
    } catch {
        showToast('si è verificato un errore')
    }
}

const disableManager = async () => {
    try {
        await client.disableManager({ userId: props.user.id, clubId: store.getters.getMyClub.club_id });
        emit('updated');
    } catch {
        showToast('si è verificato un errore')
    }
}

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (__props.user.manager_status === 'blocked')
      ? _withDirectives((_openBlock(), _createBlock(UiButton, {
          key: 0,
          size: "sm",
          "is-text": "",
          onClick: enableManager
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 512)), [
          [
            _directive_tooltip,
            'Abilita Manager',
            void 0,
            { top: true }
          ]
        ])
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (!__props.user.is_owner)
            ? _withDirectives((_openBlock(), _createBlock(UiButton, {
                key: 0,
                "is-text": "",
                variant: "danger",
                onClick: disableManager
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 512)), [
                [
                  _directive_tooltip,
                  'Disabilita Manager',
                  void 0,
                  { top: true }
                ]
              ])
            : _createCommentVNode("", true),
          (!__props.user.emailVerified)
            ? _withDirectives((_openBlock(), _createBlock(UiButton, {
                key: 1,
                "is-text": "",
                onClick: sendInviteEmail
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 512)), [
                [
                  _directive_tooltip,
                  'Invia email di invito',
                  void 0,
                  { top: true }
                ]
              ])
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})